module.exports = __webpack_public_path__ + "media/images/img-travel-11-eaa1500b.jpg";